"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymizedPassenger = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let AnonymizedPassenger = class AnonymizedPassenger {
    type;
    childSeatType;
    luggage = new Array();
    assignationId;
    isAdult() {
        return this.type === legacy_enums_1.PassengerType.Adult;
    }
    isChild() {
        return this.type === legacy_enums_1.PassengerType.Child;
    }
    isLead() {
        return this.type === legacy_enums_1.PassengerType.Lead;
    }
};
exports.AnonymizedPassenger = AnonymizedPassenger;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedPassenger.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : Number(value))),
    __metadata("design:type", Number)
], AnonymizedPassenger.prototype, "childSeatType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], AnonymizedPassenger.prototype, "luggage", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedPassenger.prototype, "assignationId", void 0);
exports.AnonymizedPassenger = AnonymizedPassenger = __decorate([
    (0, class_transformer_1.Exclude)()
], AnonymizedPassenger);
//# sourceMappingURL=AnonymizedPassenger.js.map